<template>
  <div class="com-cart ">
    <div class="serch b_white">
      <van-search
        v-model="searchText"
        :clearable="false"
        shape="round"
        @blur="getList"
        placeholder="请输入车牌号、司机姓名或司机电话"
      />
    </div>

    <van-list
      :loading="loading"
      :finished="finished"
      :offset="20"
      :immediate-check="false"
      finished-text="没有更多了"
    >
      <ul class="mar20-lr mar20-t b_white radius10">
        <li
          class="flex justify_between align_center  pad20"
          v-for="item in list"
          :key="item.shopId"
        >
          <!-- <span class="cart-status" v-if="item.isAbnormal === 1">正常</span>
          <span class="cart-status cart-status-err" v-else-if="item.isAbnormal === 2">异常</span>
          <span class="cart-status cart-status-audit" v-else>审核</span> -->
          <div class="flex_1 gray_3">
            <div class="flex align_center">
              <span class="mar15_r fb f16_rem">{{ item.licensePlateNum }}</span>
            </div>
            <div class="f14_rem ">
              {{ item.name }}

              <span class="f12_rem">{{ item.encryptionTel }}</span>
            </div>
          </div>
          <div class="flex">
            <img
              width="20"
              height="20"
              @click="addCart(item)"
              src="https://nfs.nxin.com/cms_image_36a0233e-b149-46a0-b63b-a0aeb62beaff.png"
            />
            <img
              width="20"
              height="20"
              @click="delCart(item.id)"
              class="mar20-l"
              src="https://nfs.nxin.com/cms_image_75c71b1b-642a-414e-a619-a1f1fda3924a.png"
            />
          </div>
        </li>
      </ul>
      <div class="text-center gray9" v-if="!list[0]">暂无车辆...</div>
    </van-list>
    <div class="cart-bottom">
      <span class="text-center b_red white" @click="addCart" v-if="showAdd">新增常用车辆</span>
      <div class="footer_iphone"></div>
    </div>
  </div>
</template>
<script>
// import { Toast } from 'vant';
import { mapState } from "vuex";
import { Toast, Dialog } from "vant";
import common from "@/assets/js/common";
// import common from '@/assets/js/common';

export default {
  data() {
    return {
      shopId: "",
      finished: false,
      loading: false,
      list: [],
      searchText: "",
      pageNum: 1,
      pageSize: 15,
      identityType: "",
      cusBoId: "",
      validateCust: "",
      cusId: "",
      showAdd: true
    };
  },
  computed: mapState({
    userInfo: state => state.app.userInfo
  }),
  created() {
    if (!common.isLogin(this.userInfo.id)) {
      return;
    }
    if (this.$route.query.cusBoId) {
      this.cusBoId = this.$route.query.cusBoId;
    }
    if (this.$route.query.validateCust) {
      this.validateCust = this.$route.query.validateCust;
    }
    if (this.$route.query.cusId) {
      this.cusId = this.$route.query.cusId;
    }
    this.getList(true);
  },
  methods: {
    getList(load) {
      if (load === true) {
        Toast.loading({
          mask: true,
          message: "加载中...",
          duration: 0
        });
      }
      const params = {
        searchText: this.searchText,
        cusBoId: this.cusBoId,
        validateCust: this.validateCust,
        cusId: this.cusId,
      };
      this.$store
        .dispatch("comCart/getVehicleList", params)
        .then(res => {
          Toast.clear();

          // 加载状态结束
          this.loading = false;
          if (res.code == 0) {
            this.list = res.data;
            return;
          }
          this.showAdd = false;
          // 加载更多
          this.list = [];
          if (res.msg) {
            Dialog.alert({
              message: res.msg
            });
          }
        })
        .catch(() => {
          Toast.clear();
        });
    },
    onLoad() {
      this.loading = true;
      this.clickToMore();
    },
    // 加载更多
    clickToMore() {
      this.pageNum = this.pageNum + 1;
      this.getList(false);
    },
    delCart(id) {
      const { cusBoId } = this;
      const { validateCust } = this;
      const { cusId } = this;
      Dialog.confirm({
        title: "提示",
        message: "你确定要删除吗？"
      })
        .then(() => {
          this.$store
            .dispatch("comCart/delVehicle", {
              id,
              cusBoId,
              validateCust,
              cusId
            })
            .then(res => {
              console.log(res);
              if (res.code === "0") {
                Toast.success("删除成功！");
                setTimeout(() => {
                  this.list = [];
                  this.pageNum = 1;
                  this.getList(true);
                }, 1000);
              } else {
                Toast.fail(res.msg);
              }
            });
        })
        .catch(() => {
          // on cancel
        });
    },
    addCart(row) {
      let path = "/comcart/add";
      if (row.id) {
        path += `?id=${row.id}&licensePlateNum=${row.licensePlateNum}&name=${row.name}&tel=${
          row.tel
        }&idCard=${row.idCard}&cusBoId=${this.cusBoId}&validateCust=${this.validateCust}&cusId=${this.cusId}`;
      } else {
        path = `${path}?cusBoId=${this.cusBoId}&validateCust=${this.validateCust}&cusId=${this.cusId}`;
      }
      this.$router.push({
        path
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>
